import React from 'react';

interface CSVConverterProps {
    data: any[];
    headers: string[];
    fileName: string;
    customHeaders?: { [key: string]: string }; // New prop for custom headers
}

const CSVConverter: React.FC<CSVConverterProps> = ({data, headers, fileName, customHeaders}) => {
    const getNestedValue = (obj: any, path: string) => {
        if (typeof path !== 'string') return '';
        return path.split('.').reduce((acc, part) => acc && acc[part] !== undefined ? acc[part] : '', obj);
    };

    const convertToCSV = (data: any[], headers: string[], customHeaders?: { [key: string]: string }) => {
        if (data.length === 0 || headers.length === 0) return '';

        const csvRows: string[] = [];
        const headerRow = headers.map(header => customHeaders?.[header] || header);
        csvRows.push(headerRow.join(','));

        for (const row of data) {
            const values = headers.map(header => {
                const value = getNestedValue(row, header);
                if (typeof value === 'object' && value !== null) {
                    return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
                }
                return `"${String(value).replace(/"/g, '""')}"`;
            });
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n');
    };

    const downloadCSV = () => {
        if (data.length === 0 || headers.length === 0) {
            alert("No data or headers available to download.");
            return;
        }

        const csvData = convertToCSV(data, headers, customHeaders);
        const blob = new Blob([csvData], {type: 'text/csv'});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', fileName);
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <button onClick={downloadCSV} className="btn btn-sm bs-btn me-2" disabled={data.length === 0 || headers.length === 0}>
            <i className="bi bi-download me-2"></i> Download Page Data
        </button>
    );
};

export default CSVConverter;
